export const ENV_KEYS = {
  projectName: "VITE_PROJECT_NAME",
  apiServerUrl: "VITE_API_SERVER_URL",
  apiServerFileUrl: "VITE_API_SERVER_FILE_URL",
  watcherServerUrl: "VITE_WATCHER_SERVER_URL",
  ragHubServerUrl: "VITE_RAG_HUB_SERVER_URL",
  deployLogServerUrl: "VITE_DEPLOY_LOG_SERVER_URL",
  aiNativeHubUrl: "VITE_AI_NATIVE_HUB_URL",
  helpAiChatUrl: "VITE_HELP_AI_CHAT_URL",
  publicUrl: "VITE_PUBLIC_URL",
  siteTitle: "VITE_SITE_TITLE",
  buttonStyle: "VITE_BUTTON_STYLE",
  auth: "VITE_AUTH",
  backendType: "VITE_BACKEND_TYPE",
};

export const DEFAULT_ENV = {
  projectName: "maxis",
  publicUrl: "",
  siteTitle: "MAXIS",
  buttonStyle: "default",
  auth: "false",
  backendType: "JAVA",
};
